<template>
  <base-field
    :label="$attrs.label"
    :id="$attrs.id"
    :required="$attrs.required"
    :tight="$attrs.tight"
    :error-messages="errorMessages"
  >
    <select :value="value" v-on="inputListeners" class="form-control" :disabled="$attrs.disabled">
      <option value="" disabled :selected="value === ''">{{ optionPlaceholder }}</option>
      <option
        v-for="option in options"
        :key="getOptionValue(option)"
        :value="getOptionValue(option)"
        :selected="value === getOptionValue(option)"
      >
        {{ getOptionLabel(option) }}
      </option>
    </select>
  </base-field>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import BaseField from '@/components/base-field';

export default {
  name: 'BaseSelect',
  components: {
    BaseField,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: [String, Number, Object],
      default: '',
    },
    optionPlaceholder: {
      type: String,
      default: 'Select Option',
    },
    options: {
      type: Array,
      default: () => [],
    },
    optionText: {
      type: String,
      default: 'label',
    },
    optionValue: {
      type: String,
      default: '',
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, context) {
    const innerValue = ref('');
    const customEvents = {
      change: (event) => {
        context.emit('change', event.target.value);
      },
    };
    const inputListeners = computed(() => Object.assign({}, context.listeners, customEvents));

    const getOptionLabel = (option) => {
      if (option[props.optionText]) {
        return option[props.optionText];
      }

      return option;
    };

    const getOptionValue = (option) => {
      if (option[props.optionValue]) {
        return option[props.optionValue];
      }

      return getOptionLabel(option);
    };

    return {
      innerValue,
      inputListeners,
      getOptionLabel,
      getOptionValue,
    };
  },
};
</script>
